import { useState } from 'react'
import { useAlert } from 'react-alert'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { postApi } from '../../../../../api'
import endpoints from '../../../../../config/endpoints'
import type { FormValues } from '../../../../../ui/Form'
import { INITIAL_TENANT_LICENSE_VALUES } from '../TenantLicenses.constants'
import TenantLicenseForm from '../TenantLicensesForm/TenantLicensesForm'

import type { CreateLicenseProps } from './CreateLicense.types'
import { mapFormValuesToDraftLicense } from './CreateLicense.utils'

function CreateLicense(props: CreateLicenseProps) {
  const { onLicenseCreated, isCreateLicenseDisabled } = props
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const alert = useAlert()
  const { id } = useParams()

  const handleOpenForm = () => setIsOpen(true)
  const handleCloseForm = () => setIsOpen(false)

  const handleSubmitForm = (values: FormValues) => {
    postApi({
      endpoint: endpoints.license(id),
      data: mapFormValuesToDraftLicense(values),
    })
      .then(() => {
        handleCloseForm()
        alert.success(t('Tenants.Profile.Licenses.Form.Alert.CreateSuccess'))
        onLicenseCreated()
      })
      .catch((error) => {
        alert.error(error.message)
      })
  }

  return (
    <div className="flex justify-start mb-4">
      <button
        className={`px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition ${
          isCreateLicenseDisabled ? 'opacity-60' : ''
        }`}
        disabled={isCreateLicenseDisabled}
        onClick={handleOpenForm}
      >
        {t('Tenants.Profile.Licenses.Form.CreateButton')}
      </button>
      {isOpen && (
        <TenantLicenseForm
          initialValues={INITIAL_TENANT_LICENSE_VALUES}
          titleKey="Tenants.Profile.Licenses.Form.CreateTitle"
          onSubmit={handleSubmitForm}
          onCancel={handleCloseForm}
          onClose={handleCloseForm}
        />
      )}
    </div>
  )
}

export default CreateLicense
